import { z } from 'zod';

export interface ParametersModalProps {
  isOpen: boolean;
  onClose: () => void;
  onReturn: () => void;
  onSubmit: (payload: Record<string, unknown>) => void;
}

export interface ParametersImageProps {
  image: string;
  iconSelected: string;
}

export const ParametersSchema = (comprimento: number) =>
  z.object({
    alturaColuna: z
      .number({ invalid_type_error: 'Campo obrigatório' })
      .positive({ message: 'O número deve ser maior que 0' })
      .min(6, { message: 'O valor mínimo é 6' })
      .max(12, { message: 'O valor máximo é 12' }),
    vaoPortico: z
      .number({ invalid_type_error: 'Campo obrigatório' })
      .positive({ message: 'O número deve ser maior que 0' })
      .max(50, { message: 'O valor máximo é 50' })
      .optional(),
    distanciaPortico: z
      .number({ invalid_type_error: 'Campo obrigatório' })
      .min(6, { message: 'O valor mínimo é 6' })
      .max(12, { message: 'O valor máximo é 12' })
      .refine(
        (data) => {
          const c = Math.round(comprimento * 10000);
          const d = Math.round(data * 10000);
          return c % d === 0;
        },
        {
          message: `Este valor deve permitir a partição do comprimento (${comprimento.toString().replace('.', ',')}m) em partes iguais`,
        },
      ),
    velocidadeVento: z
      .number({ invalid_type_error: 'Campo obrigatório' })
      .positive({ message: 'O número deve ser maior que 0' })
      .min(30, { message: 'O valor mínimo é 30' })
      .max(45, { message: 'O valor máximo é 45' }),
    tipologia: z.enum(['simples'], {
      invalid_type_error: 'Selecione uma tipologia',
    }),
  });

export type ParametersData = z.infer<ReturnType<typeof ParametersSchema>>;
